import React, {useState} from "react";
import TruckPayrollSetup from "./truck-payroll-setup";
import {useDispatch, useSelector} from "react-redux";
import TruckPayrollAdjustments from "./truck-payroll-adjustments";
import {useLocation} from "react-router-dom";
import LocalStorage from "../../../../common/util/localStorage";
import {
    classNames,
} from '../../../../common/util/util-helpers'
import Tippy from "@tippyjs/react";
import {Squares2X2Icon} from "@heroicons/react/20/solid";
import {Bars4Icon} from "@heroicons/react/24/outline";

export default function TruckPayrollSetupTab({translate, setIsStateDirty, TruckID}) {
    const dispatch = useDispatch();
    const location = useLocation();
    const secondResource = useSelector(state => state.secondResource);
    const thirdResource = useSelector(state => state.thirdResource);

    const [deductionData, setDeductionData] = useState({});

    const [payAdjustments, setPayAdjustments] = useState([]);

    const storage = LocalStorage.get(location.pathname.slice(0, location.pathname.lastIndexOf('/')) + "_state")

    const dataView = storage?.dataView ?? 'grid';

    const [currentView,setCurrentView] = useState(dataView)
    function handleAddPayAdjustments(params) {
        const payAdjustmentsUpdate = [...payAdjustments];
        payAdjustmentsUpdate.push(params);

        setPayAdjustments(payAdjustmentsUpdate);
    }

    function handleSetDataView(view) {
        setCurrentView(view)
    }

    return <div>
        <div className="flex justify-start items-start my-2 mx-4">
            <Tippy content={translate("text.grid_view")}>
                <button
                    onClick={() => handleSetDataView("grid")}
                    className={classNames(dataView === "grid" ? "text-primary bg-inverse" : "bg-disabled text-tm-gray-400", "-mr-px relative inline-flex items-center px-4 py-2 rounded-l-btn border border-tm-gray-300 text-sm font-medium focus:z-10 focus:outline-hidden focus:ring-1")}

                >
                    <Squares2X2Icon className="h-5 w-5" aria-hidden="true"/>
                </button>
            </Tippy>
            <Tippy content={translate("text.stacked_layout")}>
                <button
                    onClick={() => handleSetDataView("stacked_view")}
                    className={classNames(dataView === "stacked_view" ? "text-primary bg-inverse" : "bg-disabled text-tm-gray-400", "-ml-px relative inline-flex items-center px-4 py-2 rounded-r-btn border border-tm-gray-300 text-sm font-medium focus:z-10 focus:outline-hidden focus:ring-1")}
                >
                    <Bars4Icon className="h-5 w-5" aria-hidden="true"/>
                </button>
            </Tippy>
        </div>

        <div className="grid grid-cols-12 gap-x-5 gap-y-10 pb-24">
            <div className={classNames(dataView === 'grid' ? "col-span-4" : "col-span-full")}>
                <TruckPayrollSetup
                    TruckID={TruckID}
                    setIsStateDirty={setIsStateDirty}
                    getData={(item) => setDeductionData(item)}
                    translate={translate}
                    currentView={currentView}
                />
            </div>

            {/*<div className="col-span-full 3xl:col-span-8">*/}
            <div className={classNames(dataView === 'grid' ? "col-span-8" : "col-span-full")}>
                <TruckPayrollAdjustments
                    location={location}
                    deductionData={deductionData}
                    dispatch={dispatch}
                    TruckID={TruckID}
                    secondResource={secondResource}
                    thirdResource={thirdResource}
                    onAddPayAdjustment={handleAddPayAdjustments}
                    payAdjustments={payAdjustments}
                    translate={translate}
                    currentView={currentView}
                />
            </div>
        </div>
    </div>
}